import ConfiguratorTemplate from '../ConfiguratorTemplate';
import EighthInchDropdown from '../../../components/EighthInchDropdown';
// eslint-disable-next-line import/no-cycle
import WithCustomSizing from '../withCustomSizing';

export default ConfiguratorTemplate(WithCustomSizing(EighthInchDropdown, 'EighthInchDropdown'));
